/* eslint-disable no-restricted-syntax */
import { toCamelCase, toKebabCase } from './string';
import * as stylis from 'stylis';
import { get, mapValues, set } from "lodash-es";
export const zeroRect = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};
export function isRectEqual(rect1, rect2) {
  return (rect1 === null || rect1 === void 0 ? void 0 : rect1.x) === (rect2 === null || rect2 === void 0 ? void 0 : rect2.x) && (rect1 === null || rect1 === void 0 ? void 0 : rect1.y) === (rect2 === null || rect2 === void 0 ? void 0 : rect2.y) && (rect1 === null || rect1 === void 0 ? void 0 : rect1.width) === (rect2 === null || rect2 === void 0 ? void 0 : rect2.width) && (rect1 === null || rect1 === void 0 ? void 0 : rect1.height) === (rect2 === null || rect2 === void 0 ? void 0 : rect2.height);
}
export function isInsideRect(x, y, rect) {
  return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
}
export function getOffsetRect(el, offsetParent) {
  const rRect = 'getBoundingClientRect' in el ? el.getBoundingClientRect() : el;
  const pRect = offsetParent.getBoundingClientRect();
  rRect.x -= pRect.x - offsetParent.scrollLeft;
  rRect.y -= pRect.y - offsetParent.scrollTop;
  return rRect;
}
export function getRectIntersection(rect, bounds) {
  const x = Math.max(rect.x, bounds.x);
  const y = Math.max(rect.y, bounds.y);
  const right = Math.min(rect.x + rect.width, bounds.x + bounds.width);
  const bottom = Math.min(rect.y + rect.height, bounds.y + bounds.height);
  const w = Math.max(0, right - x);
  const h = Math.max(0, bottom - y);
  return new DOMRect(x, y, w, h);
}
/** 对于 css variable 或者 vendor-prefixed 的名字，不需要做 kebab 或者 camel 的转义 */
const isPreservedCssProperty = x => x.startsWith('-');
export function styleObjectToCssText(obj, opts = {}) {
  if (!obj || typeof obj !== 'object') return '';
  const ans = [];
  Object.keys(obj).forEach(rawKey => {
    const value = obj[rawKey];
    if (opts.ignoreInterop && /\{\{[\s\S]*\}\}/.test(value || '')) {
      return;
    }
    const kebabKey = isPreservedCssProperty(rawKey) ? rawKey : toKebabCase(rawKey);
    ans.push(`${kebabKey}: ${value};`);
  });
  return ans.join('\n');
}
export function cssTextToStyleObject(txt) {
  if (!txt || typeof txt !== 'string') return {};
  const obj = {};
  // 0 = composing key
  // 1 = composing value
  let state = 0;
  let key = '';
  let value = '';
  let i = 0;
  const skipTo = needle => {
    i = txt.indexOf(needle, i);
    if (i === -1) i = txt.length - 1;else i += needle.length - 1;
  };
  const popAndReset = () => {
    if (state === 1) {
      key = key.trim();
      value = value.trim();
      // 统一 camelCase
      if (!isPreservedCssProperty(key)) key = toCamelCase(key);
      // 自动加单位
      if (/^\d+$/.test(value) && isStylePropertyNeedingUnit(key)) value += 'px';
      if (key && value) obj[key] = value;
    }
    state = 0;
    key = '';
    value = '';
  };
  for (i = 0; i < txt.length; i++) {
    const ch = txt[i];
    if (ch === '/' && txt[i + 1] === '*') {
      skipTo('*/');
      continue;
    }
    // see https://www.w3.org/TR/CSS2/syndata.html#q4.0
    switch (state) {
      case 0:
        // composing key
        if (ch === ':') {
          state = 1;
          continue;
        }
        if (ch === ';') {
          // TODO: 使用反向逻辑判断，因为
          popAndReset();
          continue;
        }
        if (ch === '\\') {
          // 转义字符
          key += txt.slice(i, i + 2);
          i += 1;
          continue;
        }
        key += ch;
        continue;
      case 1:
        // composing value
        if (ch === '{' && txt[i + 1] === '{') {
          const i0 = i;
          skipTo('}}');
          value += txt.slice(i0, i + 1);
          continue;
        }
        if (ch === ';' || ch === '\n') {
          popAndReset();
          continue;
        }
        value += ch;
    }
  }
  popAndReset();
  return obj;
}
/**
 * some css properties must have a unit like `px`
 *
 * @param prop in camelCase
 */
export function isStylePropertyNeedingUnit(prop) {
  if (!prop) return false;
  const p = prop.toLowerCase().replace(/-/g, '');
  if (p === 'width' || p === 'height' || p === 'fontsize') return true;
  if (/^(margin|padding)?(left|top|right|bottom)?$/.test(p)) return true;
  if (/^border(left|top|right|bottom)?width$/.test(p)) return true;
  return false;
}
export function rect2css(rect) {
  return {
    width: `${rect.width}px`,
    height: `${rect.height}px`,
    left: `${'left' in rect ? rect.left : rect.x}px`,
    top: `${'top' in rect ? rect.top : rect.y}px`
  };
}
/**
 * 从一个 HTMLElement 或者 RectLike 获得一个 DOMRect
 */
export function toRect(place) {
  const tmp1 = '$el' in place ? place.$el : place;
  const tmp2 = 'getBoundingClientRect' in tmp1 ? tmp1.getBoundingClientRect() : tmp1;
  return new DOMRect(tmp2.x, tmp2.y, tmp2.width, tmp2.height);
}
/**
 * 计算一个 popup 的位置，输入两个元素（或者绝对定位的 Rect），输出相对于 container 的位置
 */
export function getPopupPosition(opts) {
  const rect1 = toRect(opts.anchor);
  const rect2 = toRect(opts.container);
  // 首先尝试把窗口放在下方
  let x = Math.max(0, rect1.x - rect2.x);
  let y = Math.max(0, rect1.y - rect2.y + rect1.height);
  // 计算右边、下面超出的长度
  const ro = () => Math.max(0, x + opts.width - rect2.width);
  const bo = () => Math.max(0, y + opts.height - rect2.height);
  if (!ro() && bo()) {
    // 仅下面超出了，就放到右边
    x = Math.max(0, rect1.x + rect1.width - rect2.x);
    y = Math.max(0, rect1.y - rect2.y);
  }
  if (ro() && !bo()) {
    // 仅右边超出了，就放在下面（同时向左错位）
    x = Math.max(0, rect2.width - opts.width);
    y = Math.max(0, rect1.y + rect1.height - rect2.y);
  }
  if (ro() && bo()) {
    // 右边和下面都超出了，就放到 anchor 左边
    x = Math.max(0, rect1.x - opts.width - rect2.x);
    y = Math.max(0, rect1.y - rect2.y);
  }
  if (bo()) {
    // 最后的倔强，如果底部太低，就向上娜一点
    y = Math.max(0, rect2.height - Math.max(300, opts.height));
  }
  return {
    x,
    y
  };
}
const boxModelMeasurmentKeys = ['width', 'height', 'paddingLeft', 'paddingTop', 'paddingRight', 'paddingBottom', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'borderLeftWidth', 'borderTopWidth', 'borderRightWidth', 'borderBottomWidth'];
export function normalizeBoxModel(style) {
  const ans = {};
  boxModelMeasurmentKeys.forEach(key => {
    ans[key] = parseFloat(style[key]);
  });
  return ans;
}
export function getMainAxisInfo(el) {
  const style = getComputedStyle(el);
  const isFlex = style.display === 'flex';
  const vertical = isFlex === false || /column/.test(style.flexDirection);
  const reversed = isFlex && /-reverse$/.test(style.flexDirection);
  const isNoWrapFlex = isFlex && style.flexWrap === 'nowrap';
  const direction = `${vertical ? 'column' : 'row'}${reversed ? '-reversed' : ''}`;
  return {
    isFlex,
    isNoWrapFlex,
    direction
  };
}
/**
 * 根据 direction 计算一个点在容器中 mainAxis 所处的位置（取值范围 0-1）
 */
export function getMainAxisPos(x, y, slotRect, direction) {
  switch (direction) {
    case 'row':
      return (x - slotRect.left) / slotRect.width;
    case 'row-reversed':
      return (slotRect.right - x) / slotRect.width;
    case 'column':
      return (y - slotRect.top) / slotRect.height;
    case 'column-reversed':
      return (slotRect.bottom - y) / slotRect.height;
    default:
      return 0;
  }
}
/**
 * 根据 direction 计算一个子元素在容器中 mainAxis 所处的位置（取值范围 0-1）
 */
export function getMainAxisRange(rect, slotRect, direction) {
  let begin = 0;
  let end = 0;
  switch (direction) {
    case 'row':
      begin = (rect.left - slotRect.left) / slotRect.width;
      end = (rect.right - slotRect.left) / slotRect.width;
      break;
    case 'row-reversed':
      begin = (slotRect.right - rect.right) / slotRect.width;
      end = (slotRect.right - rect.left) / slotRect.width;
      break;
    case 'column':
      begin = (rect.top - slotRect.top) / slotRect.height;
      end = (rect.bottom - slotRect.top) / slotRect.height;
      break;
    case 'column-reversed':
      begin = (slotRect.bottom - rect.bottom) / slotRect.height;
      end = (slotRect.bottom - rect.top) / slotRect.height;
      break;
  }
  return {
    begin,
    end
  };
}
// 获取两个rect中间的间距
export function getSpaceBetweenTwoRect(rect, container) {
  const bound = {
    top: rect.top - container.top,
    left: rect.left - container.left,
    right: container.x + container.width - rect.x - rect.width,
    bottom: container.y + container.height - rect.y - rect.height
  };
  return bound;
}
const compileMW = stylis.middleware([stylis.prefixer, el => {
  if (el.type === 'decl') return '\n  ';
  if (el.type === 'rule') {
    el.props = el.props.map(x => `\n${x}`);
    return '\n';
  }
}, stylis.stringify]);
export function compileSCSS(input) {
  return stylis.serialize(stylis.compile(input), compileMW);
}
/**
 * 将 UICore.Layout 里的 extraStyle 生成 CSS，以便创建 `<style>` 标签
 *
 * @returns
 */
export function compileLayoutExtraStyle(o, opts = {}) {
  // const o = { ...layout.extraStyle };
  // if (layout.style) o[''] = { '': { ...layout.style, ...o['']?.[''] }, ...o[''] };
  if (!o) return '';
  const INDENT = '  ';
  const generator = function* () {
    for (const selector of Object.keys(o)) {
      const sub = o[selector];
      if (!sub || !Object.keys(sub).length) continue;
      const i0 = selector && INDENT;
      if (selector) yield `${selector} {`;
      for (const pseudoClass of Object.keys(sub)) {
        const style = sub[pseudoClass];
        if (!style || !Object.keys(style).length) continue;
        if (pseudoClass) yield `${i0}${pseudoClass} {`;
        yield styleObjectToCssText(style, opts).replace(/^/gm, i0 + (pseudoClass ? INDENT : ''));
        if (pseudoClass) yield `${i0}}`;
      }
      if (selector) yield '}';
      yield '';
    }
  }();
  return Array.from(generator).join('\n');
}
/** 把stylis.compile的结果转为LayoutExtraStyle */
export const scss2ExtraStyle = source => {
  const compiled = stylis.compile(source);
  const extraStyle = {};
  compiled.forEach(item => {
    if (item.type === 'decl' && typeof item.props === 'string') {
      // '' ''
      set(extraStyle, ['', '', item.props], item.children);
    } else if (item.type === 'rule') {
      if (item.parent === null && item.value.includes('&') && Array.isArray(item.children)) {
        // '' &hover
        item.children.forEach(children => {
          set(extraStyle, ['', item.value.replace('\f', ''), get(children, 'props')], get(children, 'children'));
        });
      } else if (item.parent && item.value.includes('&') && Array.isArray(item.children)) {
        // div &hover
        const {
          parent
        } = item;
        item.children.forEach(children => {
          set(extraStyle, [parent.value, item.value.replace('\f', ''), get(children, 'props')], get(children, 'children'));
        });
      }
      // div 丢弃
    }
  });
  return extraStyle;
};
export const safePxAdd = (px1, px2, append) => {
  const pxInt = [px1, px2].map(item => {
    if (typeof item === 'string') {
      return parseInt(item.replace('px', ''), 10);
    }
    return item;
  }).reduce((a, b) => a + b).toFixed(0);
  if (append) {
    return `${pxInt}${append}`;
  }
  return parseFloat(pxInt);
};
export function number2Px(style) {
  return mapValues(style, value => {
    if (typeof value === 'number') return `${value}px`;
    return value;
  });
}
//# sourceMappingURL=styling.js.map
